export default __webpack_public_path__ + "static/media/properties.7e8dc8da.svg";